import { render, staticRenderFns } from "./deal-summay.vue?vue&type=template&id=150e6b7c&scoped=true"
import script from "./deal-summay.vue?vue&type=script&lang=js"
export * from "./deal-summay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150e6b7c",
  null
  
)

export default component.exports